import { render } from "./Icon-Svg.vue?vue&type=template&id=2b85e43d&scoped=true"
import script from "./Icon-Svg.vue?vue&type=script&lang=js"
export * from "./Icon-Svg.vue?vue&type=script&lang=js"

import "./Icon-Svg.vue?vue&type=style&index=0&id=2b85e43d&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b85e43d"]])

export default __exports__